import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import branding from 'shared/app/model/branding';
import { usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { MaterialBoolControl } from 'console/shared/components/fields';
import { memo, useCallback, useContext, useState } from 'react';
import { Z3KSettings } from '../../provider/types';
import { selectDevice } from 'entities/device/lib';
export const UISystemTabs = memo(function SystemTabs() {
    const { device_id, save_device_settings } = useContext(Z3KSettings);
    const device = usePartialAppSelector(selectDevice, device_id);
    const show_heating = device?.show_heating_tab;
    const [temp_show_heating, setTempShowHeating] = useState(!!show_heating);
    const show_cams = device?.cams_show;
    const [temp_show_cams, setTempShowCams] = useState(!!show_cams);
    const onHeatingChange = useCallback((heating_settings) => {
        setTempShowHeating(heating_settings);
        save_device_settings({
            show_heating_tab: heating_settings,
        });
    }, [save_device_settings, setTempShowHeating]);
    const onCamsChange = useCallback((cams_settings) => {
        setTempShowCams(cams_settings);
        save_device_settings({
            cams_show: cams_settings,
        });
    }, [save_device_settings, setTempShowCams]);
    return (_jsxs(Box, { children: [branding.can_hide_heating_tab && (_jsx(Box, { mt: 2, children: _jsx(MaterialBoolControl, { value: temp_show_heating, label: "\u041F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u0432\u043A\u043B\u0430\u0434\u043A\u0443 \u043E\u0442\u043E\u043F\u043B\u0435\u043D\u0438\u0435", onChange: onHeatingChange, help_id: "enable_heating_tab" }) })), branding.show_cams && (_jsx(MaterialBoolControl, { value: temp_show_cams, label: "\u041F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u0432\u043A\u043B\u0430\u0434\u043A\u0443 \u043A\u0430\u043C\u0435\u0440\u044B", onChange: onCamsChange, help_id: "enable_cams_tab" }))] }));
});
